import * as React from "react";
import useGeneralMetricsSearch from "./hooks/useGeneralMetricsSearch";
import WelcomeSearch from "./WelcomeSearch";
import WelcomeSearchSkeleton from "./WelcomeSearchSkeleton";
const GeneralWelcomeMetrics = ({ topSourcesOnly = false }) => {
  const { view, entries } = useGeneralMetricsSearch(topSourcesOnly);
  return /* @__PURE__ */ React.createElement(WelcomeSearch, { view, loadingPlaceholder: /* @__PURE__ */ React.createElement(WelcomeSearchSkeleton, { entries }) });
};
export default GeneralWelcomeMetrics;
